// extracted by mini-css-extract-plugin
export var productImage = "_mz-0";